const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
const API_ENDPOINT = IS_DEVELOPMENT
  ? 'https://widget-data-stage.elfsight.dev/api'
  : 'https://widget-data.service.elfsight.com/api';

export const meta = {
  appAlias: 'photo-gallery',
  appName: 'Photo Gallery',
  stylePrefix: 'eapp-photo-gallery',
  apiUrl: API_ENDPOINT,
  sourceUrl: `${API_ENDPOINT}/source/photos`,
  pickerUrl: `${API_ENDPOINT}/google-photos-picker`,
  pickerAuthUrl: `${API_ENDPOINT}/auth/google-photos-picker`,
  photosUrl: `${API_ENDPOINT}/photos`,
  authUrl: `${API_ENDPOINT}/auth/google-photos`,
  albumsUrl: `${API_ENDPOINT}/google-photos/albums`
};
